import Color2 from '../assets/colors/Color__0002_Rose-Grey.png';
import Color3 from '../assets/colors/Color__0003_Flea-Bitten-Grey.png';
import Color4 from '../assets/colors/Color__0004_White-Grey.png';
import Color5 from '../assets/colors/Color__0005_White.png';
import Color6 from '../assets/colors/Color__0006_Smoky-Cream.png';
import Color7 from '../assets/colors/Color__0007_Smoky-Black-2.png';
import Color8 from '../assets/colors/Color__0008_Smoky-Black.png';
import Color9 from '../assets/colors/Color__0009_Red-Dun.png';
import Color10 from '../assets/colors/Color__0010_Perlino.png';
import Color11 from '../assets/colors/Color__0011_Palomino.png';
import Color12 from '../assets/colors/Color__0012_Grullo.png';
import Color13 from '../assets/colors/Color__0013_Dapple-Grey.png';
import Color14 from '../assets/colors/Color__0014_Steel-Grey.png';
import Color15 from '../assets/colors/Color__0015_Gold-Cream.png';
import Color16 from '../assets/colors/Color__0016_Gold-Champagne.png';
import Color18 from '../assets/colors/Color__0018_Dunskin-2.png';
import Color19 from '../assets/colors/Color__0019_Dunskin-1.png';
import Color20 from '../assets/colors/Color__0020_Dunalino.png';
import Color21 from '../assets/colors/Color__0021_Cremello.png';
import Color22 from '../assets/colors/Color__0022_Classic-Cream.png';
import Color23 from '../assets/colors/Color__0023_Classic-Champagne.png';
import Color24 from '../assets/colors/Color__0024_Bay-Dun.png';
import Color25 from '../assets/colors/Color__0025_Seal-Brown.png';
import Color26 from '../assets/colors/Color__0026_Mahogany-Bay.png';
import Color27 from '../assets/colors/Color__0027_Chestnut-Pseudo-Double-Pearl.png';
import Color28 from '../assets/colors/Color__0028_Liver-Chestnut.png';
import Color29 from '../assets/colors/Color__0029_Sorrel-Chestnut.png';
import Color30 from '../assets/colors/Color__0030_Flaxen-Chestnut.png';
import Color31 from '../assets/colors/Color__0031_Light-Chestnut.png';
import Color32 from '../assets/colors/Color__0032_Buck-Skin.png';
import Color33 from '../assets/colors/Color__0033_Black-Pseudo-Double-Pearl.png';
import Color34 from '../assets/colors/Color__0034_Black-Pearl.png';
import Color35 from '../assets/colors/Color__0035_Jet-Black.png';
import Color36 from '../assets/colors/Color__0036_Faded-Black.png';
import Color37 from '../assets/colors/Color__0037_Bay-Pseudo-Double-Pearl.png';
import Color38 from '../assets/colors/Color__0038_Bay-Pearl.png';
import Color39 from '../assets/colors/Color__0039_Seal-Bay-Dun.png';
import Color40 from '../assets/colors/Color__0040_Wild-Bay-Dun.png';
import Color41 from '../assets/colors/Color__0041_Standard-Bay.png';
import Color42 from '../assets/colors/Color__0042_Blood-Bay.png';
import Color43 from '../assets/colors/Color__0043_Copper-Bay.png';
import Color44 from '../assets/colors/Color__0044_Wild-Bay.png';
import Color45 from '../assets/colors/Color__0045_Golden-Bay.png';
import Color46 from '../assets/colors/Color__0046_Apricot.png';
import Color47 from '../assets/colors/Color__0047_Amber-Cream-2.png';
import Color48 from '../assets/colors/Color__0048_Amber-Cream.png';
import Color49 from '../assets/colors/Color__0049_Amber-Champagne.png';
export class ColorData {
    constructor(name, src) {
        this.name = name;
        this.src = src;
    }
}
export const ColorFilterOptions = [
    {
        title: 'Bays',
        colors: [
            new ColorData('Golden Bay', Color45),
            new ColorData('Wild Bay', Color44),
            new ColorData('Copper Bay', Color43),
            new ColorData('Blood Bay', Color42),
            new ColorData('Standard Bay', Color41),
            new ColorData('Mahogany Bay', Color26),
            new ColorData('Seal Brown', Color25)
        ]
    },
    {
        title: 'Chestnuts',
        colors: [
            new ColorData('Light Chestnut', Color31),
            new ColorData('Flaxen Chestnut', Color30),
            new ColorData('Sorrel Chestnut', Color29),
            new ColorData('Liver Chestnut', Color28)
        ]
    },
    {
        title: 'Blacks/Greys/White',
        colors: [
            new ColorData('Faded Black', Color36),
            new ColorData('Jet Black', Color35),
            new ColorData('White Grey', Color4),
            new ColorData('Flea Bitten Grey', Color3),
            new ColorData('Rose Grey', Color2),
            new ColorData('Steel Grey', Color14),
            new ColorData('Dapple Grey', Color13),
            new ColorData('White', Color5)
        ]
    },
    {
        title: 'Duns',
        colors: [
            new ColorData('Bay Dun', Color24),
            new ColorData('Wild Bay Dun', Color40),
            new ColorData('Seal Bay Dun', Color39),
            new ColorData('Grullo', Color12),
            new ColorData('Red Dun', Color9)
        ]
    },
    {
        title: 'Champagnes & Creams',
        colors: [
            new ColorData('Classic Champagne', Color23),
            new ColorData('Gold Champagne', Color16),
            new ColorData('Amber Champagne', Color49),
            new ColorData('Classic Cream', Color22),
            new ColorData('Gold Cream', Color15),
            new ColorData('Amber Cream', Color48),
            new ColorData('Amber Cream 2', Color47),
            new ColorData('Smoky Cream', Color6),
            new ColorData('Smoky Black', Color8),
            new ColorData('Smoky Black 2', Color7)
        ]
    },
    {
        title: 'Pearls',
        colors: [
            new ColorData('Bay Pearl', Color38),
            new ColorData('Bay Pseudo Double Pearl', Color37),
            new ColorData('Black Pearl', Color34),
            new ColorData('Black Pseudo Double Pearl', Color33),
            new ColorData('Apricot', Color46),
            new ColorData('Chestnut Pseudo Double Pearl', Color27)
        ]
    },
    {
        title: 'Alt Creams',
        colors: [
            new ColorData('Buck Skin', Color32),
            new ColorData('Perlino', Color10),
            new ColorData('Palomino', Color11),
            new ColorData('Cremello', Color21),
            new ColorData('Dunalino', Color20),
            new ColorData('Dunskin 1', Color19),
            new ColorData('Dunskin 2', Color18)
        ]
    }
];
